import { Group, Tabs } from "@mantine/core";
import { IIssueBoardApi } from "@mcapps/shared";
import React from "react";
import { AccessView } from "../../../components/AccessComp/AccessComp";
import IssueBoardSelector from "./IssueBoardSelector";
import { getIssueRegisterNameOption } from "./issueUtils";

const IssueTabs: React.FC<{
  activeTab: string;
  setActiveTab: any;
  activeBoard: IIssueBoardApi;
}> = ({ activeTab, setActiveTab, activeBoard }) => {
  return (
    <Group
      justify="space-between"
      align="end"
      pt="xs"
      mx="xs"
      wrap="nowrap"
      style={{ boxShadow: "inset 0 -2px 0 0 #e4e7eb" }}
    >
      <Tabs value={activeTab} onChange={(v) => setActiveTab(v ?? "issues")} styles={{ tab: { fontWeight: 600 } }}>
        <Tabs.List>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="issues">
            {getIssueRegisterNameOption(activeBoard?.issueNameSetting, "register")}
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="settings">
            <i className="fa fa-cog fa-fw icon-black-50" /> Innstillinger
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="logs">
            <i className="fa fa-book fa-fw icon-black-50" /> Historikk
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Group gap="sm" wrap="nowrap" pb={"xs"}>
        <AccessView access={activeBoard.access as any} variant="md" />
        <IssueBoardSelector />
      </Group>
    </Group>
  );
};

export default IssueTabs;
